import { IUser } from "../hooks/auth/models";
import settings from "../utilities/settings";

const rolesConfig = settings?.Roles ?? {};

// Nomi dei ruoli centralizzati da configurazione (con fallback ai default storici)
// per evitare hardcoding sparso nei componenti.
export const Roles = {
    DevSuperAdmin: rolesConfig.DevSuperAdmin ?? 'DevSuperAdmin',
    SuperAdmin: rolesConfig.SuperAdmin ?? 'SuperAdmin',
    Admin: rolesConfig.Admin ?? 'Admin',
    AdminFinance: rolesConfig.AdminFinance ?? 'AdminFinance',
    AdminItalianEntity: rolesConfig.AdminItalianEntity ?? 'AdminItalianEntity',
    Association: rolesConfig.Association ?? 'Association',
    Company: rolesConfig.Company ?? 'Company',
};

// Ruoli che danno accesso all'area "Amministrazione" (entry point header + pannello).
export const adminAreaRoles: string[] = rolesConfig.AdminAreaRoles ?? [
    Roles.DevSuperAdmin,
    Roles.SuperAdmin,
    Roles.Admin,
    Roles.AdminFinance,
    Roles.AdminItalianEntity,
];

export const hasUserRole = (user: IUser | undefined, roleToCheck: string): boolean => {
    const roles = user?.role;
    if (!roles) {
        return false;
    }
    if (Array.isArray(roles)) {
        return roles.includes(roleToCheck);
    }
    return roles === roleToCheck;
};

export const hasAnyUserRole = (user: IUser | undefined, rolesToCheck: string[]): boolean =>
    rolesToCheck.some((role) => hasUserRole(user, role));

export const isDevSuperAdminUser = (user: IUser | undefined): boolean =>
    hasUserRole(user, Roles.DevSuperAdmin);

export const isSuperAdminUser = (user: IUser | undefined): boolean =>
    hasUserRole(user, Roles.SuperAdmin);

export const isAdminFinanceUser = (user: IUser | undefined): boolean =>
    hasUserRole(user, Roles.AdminFinance);

export const isAdminItalianEntityUser = (user: IUser | undefined): boolean =>
    hasUserRole(user, Roles.AdminItalianEntity);

export const isNationalEntityUser = (user: IUser | undefined): boolean =>
    user?.['is-national-entity'] === true;

const convertUserTypes = (user: IUser): IUser => {
    return {
      ...user,
      enableduser: user.enableduser === 'True' ? true :
                 user.enableduser === 'False' ? false :
                 user.enableduser === null || user.enableduser === undefined ? false :
                 user.enableduser === true ? true :
                 user.enableduser === false ? false :
                 false,
      approvedfromassociation: typeof user.approvedfromassociation === 'string' ? parseInt(user.approvedfromassociation, 10) : user.approvedfromassociation,
      approvedfromAdmin: typeof user.approvedfromAdmin === 'string' ? parseInt(user.approvedfromAdmin, 10) : user.approvedfromAdmin,
    };
};

export const checkUserEnabled = (_user: IUser) => {
    const user = convertUserTypes(_user);
    switch (user.userType) {
        case 'Private':
            if (!user.enableduser || user.approvedfromassociation !== 1) {
                return false;
            }
            return true;
        case 'Association':
        case 'Company':
            if (!user.enableduser || user.approvedfromAdmin !== 1) {
                return false;
            }
            return true;
        default:
            return false;
    }
      
};
  
export const checkIfUserIsCompanyOrAssociation = (_user: IUser):boolean => {
    const user = convertUserTypes(_user);
    switch (user.userType) {
        case 'Private':
                return false;
        case 'Association':
        case 'Company':
                return true;
        default:
            return false;
    }
}

